const client = process.env.VUE_APP_CLIENT || ''
const path = `${client}/main.scss`
import(`@/styles/${path}`).catch(() => {})
